import { css } from 'styled-components';
import { TypographyName } from '../../theme/typography';
import { getTypography } from '../../theme/utils';
export const highlightsStyle = _ref => {
  let {
    theme
  } = _ref;
  return css(["span{display:inline-block;", " line-height:1;border-right:1px solid ", ";padding-right:0.5rem;margin-right:0.5rem;&:last-of-type{border-right:0;padding-right:0;margin-right:0;}}"], getTypography(theme, TypographyName.SMALL), theme.palettes.neutrals.light);
};
//# sourceMappingURL=Highlights.style.js.map